export const MIN_SCALE_X = 0.1;
export const MIN_SCALE_Y = 0.1;
export const MIN_SCALE_Z = 0.1;
export const MIN_SCALE = 0.1;
export const MAX_SCALE_X = 50;
export const MAX_SCALE_Y = 50;
export const MAX_SCALE_Z = 50;
export const MAX_SCALE = 50;
